import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import {
  hasAccessPermissions,
  isCapabilityEnabledForCurrentCompany,
} from './utils';
import auth from './auth';

/**
 * Route guard = capability (product package) + role.
 *
 * - `requiredCapability` — show/hide by product profile (primary gate).
 * - `allowedRoles` — use ANY_ROLE for product screens; restrict only
 *   Administration (`ADMIN_ROLES` / SuperAdmin for Companies).
 * - Do not use role to hide a capability the package includes.
 * - Do **not** pass `deniedProfiles`.
 */
const ProtectedRoute = ({
  component: Component,
  allowedRoles,
  deniedRoles,
  requiredCapability,
  user,
  setUser,
  ...rest
}) => {
  const allowed = hasAccessPermissions(allowedRoles);
  const deniedByRole =
    Array.isArray(deniedRoles) &&
    deniedRoles.length > 0 &&
    hasAccessPermissions(deniedRoles);

  let capabilityOk = true;
  if (requiredCapability != null) {
    const codes = Array.isArray(requiredCapability)
      ? requiredCapability
      : [requiredCapability];
    capabilityOk = codes.some(code =>
      isCapabilityEnabledForCurrentCompany(code)
    );
  }

  const isAuthorized = allowed && !deniedByRole && capabilityOk;
  return (
    <Route
      {...rest}
      render={props => {
        if (auth.isAuthenticated()) {
          if (isAuthorized) {
            return (
              <Component
                user={user}
                key={rest?.key || 'default'}
                setUser={setUser}
                {...rest}
                {...props}
              />
            );
          } else {
            return (
              <div className="admin-contact">
                <span>
                  Sorry, you don't have access to this page. Kindly check your
                  internet connection or contact your admin.
                </span>
              </div>
            );
          }
        } else {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRoute;
